export interface ApiGetPatentPumRequest {
    patentId: string;
    lang: string;
}

interface PropertyItem {
    raw_unit: string;
    display_name: string;
    raw_measurement: string;
    index: number;
}

export interface ApiGetPatentPumResponse {
    MATERIAL_PUM: PropertyItem[];
    MATERIAL_PUM_TRAN: PropertyItem[];
}

export const GetPatentPum = Symbol.for('GetPatentPum');

export interface GetPatentPum {
    getPatentPum(request: ApiGetPatentPumRequest): Promise<ApiGetPatentPumResponse>;
}
